export type ExceptionProperties = Record<string, unknown>;

export function serializeUnknownValue(value: unknown): string {
  if (typeof value === 'string') return value;
  if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'bigint' ||
    value === null ||
    value === undefined
  ) {
    return String(value);
  }

  try {
    return JSON.stringify(value);
  } catch {
    return Object.prototype.toString.call(value);
  }
}

export function normalizeException(error: unknown): Error {
  if (error instanceof Error) return error;

  const normalized = new Error(serializeUnknownValue(error));
  normalized.name =
    typeof error === 'object' && error && 'name' in error && typeof error.name === 'string'
      ? error.name
      : 'NonErrorException';

  return normalized;
}
